'use client';

import {AssetProps, OptimizedAssetFragment} from '@/components';
import {LOCAL_POSA_ASSETS_PATH} from '@/constants';

export function getStaticAssetPath(filename: string) {
	return `${LOCAL_POSA_ASSETS_PATH}/${filename}`;
}

/**
 * @deprecated - Upload asset to hygraph for use is preferred
 */
export function getStaticAssetProps(filename: string): AssetProps['asset'] {
	const localAssetPath = `${LOCAL_POSA_ASSETS_PATH}/${filename}`;
	const [name, ext] = filename?.split('.');
	const mimeType = `image/${ext}`;
	const props: AssetProps['asset'] = {
		__typename: 'Asset',
		id: name,
		mimeType,
		url: localAssetPath,
		fileName: filename,
		fallbackImage: {
			__typename: 'Asset',
			id: `local-asset-${name}`,
			url: localAssetPath,
			optUrl: localAssetPath,
			fileName: filename
		}
	};

	return props;
}

export const getOptAsset = (
	asset?: OptimizedAssetFragment | null
): OptimizedAssetFragment | null | undefined => {
	if (!asset) return asset;
	if (!asset.optUrl) return asset;
	return {...asset, url: asset.optUrl || asset.url};
};
